module.exports = __webpack_public_path__ + "static/img/uploadid.6037d2f6.6037d2f6.png";